import React from 'react'
import { motion } from 'framer-motion'

import ServiceCard from './ServiceCard.jsx'

import Magazines from '../../Magazines/Magazines'
import { fadeIn, textVariant } from '../../utils/motion'
import { services } from '../../Constants'

const Skill = () => {
  return (
    <>
      <motion.div className='px-2 mt-10 m560:mt-0' variants={textVariant()}>
        <p className='sm:text-[18px] text-[14px] text-primary dark:text-secondary tracking-wider uppercase'>
          Introduction.
        </p>
        <h2 className='dark:text-white text-[#915eff] font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]'>
          Overview,
        </h2>
      </motion.div>
      <motion.p
        variants={fadeIn('', '', 0.1, 1)}
        className='mt-4 text-gray-500 dark:text-secondary text-[17px] max-w-3xl leading-[30px] px-2.5'
      >
        I'm a skilled software developer with experience in Typescript,
        Javascript and expertise in frameworks like React, Node.js and Three.js.
        I'm a quick learner and collaborate colosely with client to create
        efficient, scalable and user-friendly solutions that solve real-word
        problems. Let's work together to bring your ideas to life.
      </motion.p>
      <section className='mt-20 flex flex-wrap gap-10 '>
        {services.map((service, index) => (
          <ServiceCard key={service.title} index={index} {...service} />
        ))}
      </section>
    </>
  )
}

export default Magazines(Skill, 'skills')
